/* 🤖 this file was generated by svg-to-ts */
export const siriusCaretRightSmall: {
  name: 'caret_right_small';
  data: string;
} = {
  name: 'caret_right_small',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.22 7.532a.75.75 0 0 1 1.06 0l3.937 3.938a.75.75 0 0 1 0 1.06l-3.937 3.938a.75.75 0 0 1-1.06-1.06L13.626 12 10.22 8.593a.75.75 0 0 1 0-1.06Z" fill="currentColor"/></svg>`
};
